/* eslint-disable */
/**
 * SessionValidator — checks if user is authenticated via httpOnly cookie
 * Used for cross-subdomain SSO between admin.saludti.es and web.saludti.es
 */

import * as url from "Helper/UrlHelper";
import { getData } from "utils/Gateway";

/**
 * Validates session using httpOnly cookie.
 * If valid, updates localStorage with user data.
 * Returns: { isValid: boolean, userData: object | null }
 */
export const validateSession = async () => {
  try {
    const requestURL = url.API_BASE_URL + url.API_AUTH_VALIDATE;

    // This call uses the cookie automatically (httpOnly)
    // No need to pass token since it's sent via cookie
    const response = await getData(requestURL);

    if (response.status && response.data) {
      // Valid session found! Update localStorage so the app recognizes the user
      localStorage.setItem("userInfo", JSON.stringify(response.data));
      localStorage.setItem("userID", JSON.stringify(response.data._id));
      localStorage.setItem("token", "authenticated"); // Marker for isLoggedIn check
      localStorage.setItem("ecosystem", response.ecosystemid);
      localStorage.setItem("ecosystemslug", response.ecosystemslug);
      localStorage.setItem("ecosystemlogo", response.ecosystemlogo);

      if (response.data.language) {
        localStorage.setItem("userLanguage", response.data.language);
      }

      return { isValid: true, userData: response.data };
    }

    return { isValid: false, userData: null };
  } catch (error) {
    console.error("Session validation error:", error);
    return { isValid: false, userData: null };
  }
};

/**
 * Clears all session data from localStorage
 */
export const clearSession = () => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("userID");
  localStorage.removeItem("token");
  localStorage.removeItem("ecosystem");
  localStorage.removeItem("ecosystemslug");
  localStorage.removeItem("ecosystemlogo");
  localStorage.removeItem("userLanguage");
};
